import {
  AttachmentLinkField,
  ImageField,
  LinkField,
  StringField,
} from "../../../types/types";
import {
  ContactCardsField,
  ContactCardsFields,
} from "../types/ContactCards.types";

export class ContactCardModel {
  private readonly fields?: ContactCardsField;
  constructor(props: ContactCardsFields) {
    this.fields = props?.fields;
  }

  get CTA(): LinkField | undefined {
    return this.fields?.CTA;
  }

  get country(): StringField | undefined {
    return this.fields?.country;
  }

  get curriculum(): StringField | undefined {
    return this.fields?.curriculum;
  }

  get curriculumTextModal(): StringField | undefined {
    return this.fields?.curriculumTextModal;
  }

  get image(): ImageField | undefined {
    return this.fields?.image;
  }
  get imageMobile(): ImageField | undefined {
    return this.fields?.ImageMobile;
  }

  get cardImageDesktop() : ImageField | undefined {
    return this.fields?.CardImageDesktop;
  }

  get designation(): StringField | undefined {
    return this.fields?.designation;
  }

  get download(): AttachmentLinkField | undefined {
    return this.fields?.download;
  }
  get SecondaryDownloadLink(): AttachmentLinkField | undefined {
    return this.fields?.SecondaryDownloadLink;
  }
  get SecondaryDownloadlinkText(): StringField | undefined {
    return this.fields?.SecondaryDownloadlinkText;
  }
  get description(): StringField | undefined {
    return this.fields?.description;
  }

  get email(): LinkField | undefined {
    return this.fields?.email;
  }

  get emailText(): StringField | undefined {
    return this.fields?.emailText;
  }
  get mobile1(): StringField | undefined {
    return this.fields?.mobile1;
  }
  get mobile2(): StringField | undefined {
    return this.fields?.mobile2;
  }

  get fullname(): StringField | undefined {
    return this.fields?.fullname;
  }

  get primaryTarget(): StringField | undefined {
    return this.fields?.primarylinktarget;
  }
  get secondaryTarget(): StringField | undefined {
    return this.fields?.secondarylinktarget;
  }
  get allowFallbackForMobile(): boolean {
    return !!this.fields?.AllowFallbackForMobile?.value;
  }

  get titleButtons(): StringField | undefined {
    return this.fields?.TitleButtons;
  }
}
